import React from 'react';

interface BatchAction {
  label: string;
  onClick: () => void;
  variant?: 'primary' | 'danger' | 'default';
}

interface BatchActionsBarProps {
  count: number;
  onClear: () => void;
  actions: BatchAction[];
  scopeLabel?: string; // e.g. "病患" or "預約"
}

const variantClasses: Record<string, string> = {
  primary: 'bg-brand-blue text-white hover:bg-brand-blue/90',
  danger: 'bg-rose-600 text-white hover:bg-rose-500',
  default: 'bg-white text-slate-700 hover:bg-slate-50',
};

export const BatchActionsBar: React.FC<BatchActionsBarProps> = ({ count, onClear, actions, scopeLabel = '項目' }) => {
  if (count === 0) return null;
  return (
    <div
      className="mb-3 flex flex-wrap items-center gap-3 rounded-xl border border-brand-blue/30 bg-brand-blue/5 px-4 py-3 text-sm backdrop-blur"
      role="status"
      aria-live="polite"
    >
      <span className="font-semibold text-brand-blue">已選取 {count} 個{scopeLabel}</span>
      <div className="flex flex-wrap items-center gap-2">
        {actions.map(a => (
          <button
            key={a.label}
            type="button"
            onClick={a.onClick}
            className={`rounded-md px-3 py-1.5 text-xs font-semibold shadow-sm transition focus:outline-none focus:ring-2 focus:ring-brand-blue/50 ${variantClasses[a.variant ?? 'default']}`}
          >
            {a.label}
          </button>
        ))}
        <button
          type="button"
          onClick={onClear}
          className="rounded-md px-3 py-1.5 text-xs font-semibold text-slate-500 hover:text-slate-700 focus:outline-none"
        >
          清除
        </button>
      </div>
    </div>
  );
};

export default BatchActionsBar;
